import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {AccountComponent} from '../account.component';
import {AccountIndexComponent} from '../account-index/account-index.component';
import {IconUsersComponent} from '../../../resources/components/icons/icon-users/icon-users.component';
import {AccountViewComponent} from '../account-view/account-view.component';
import {routerHandler} from "../../../resources/utils/router";
import {AccountViewChildrenRoutes} from "../account-view/account-view-children.routes";

export const ModeratorRoutes: Routes = [
  {
    path: 'accounts',
    data: {
      title: 'Accounts',
      breadcrumbs: 'Accounts',
      icon: IconUsersComponent
    },
    component: AccountComponent,
    canActivate: [AuthUsersGuard],
    children: [
      routerHandler.index('account', {component: AccountIndexComponent}),
      routerHandler.view('account', {component: AccountViewComponent, children: AccountViewChildrenRoutes}),
    ],
  },

];

@NgModule({
  imports: [RouterModule.forChild(ModeratorRoutes)],
  exports: [RouterModule]
})
export class AccountRoutesModule {
}
